import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

/**
 * @typedef {Object} ChakraInputProps
 * @property {React.RefObject<HTMLInputElement>} customRef
 * @property {string} displayPrefix - Prefix to display before the input
 * @property {ChakraInputProps & import('@chakra-ui/react').InputProps} props
 * @param {ChakraInputProps} customRef
 * @param {string} displayPrefix
 * @param {import('@chakra-ui/react').InputProps} rest
 * @returns
 */
export default function ChakraInput({ customRef, displayPrefix, ...rest }) {
    const { darkMode } = useSelector((state) => state.settings);

    const inputProps = {
        ...rest,
        ref: customRef,
        color: darkMode ? 'dark.textDark' : null,
        background: darkMode ? 'dark.bgDark' : null,
        borderColor: darkMode ? 'dark.tcap-borderGray' : null,
    };

    // If displayPrefix is provided, wrap input in InputGroup with InputLeftElement
    if (displayPrefix) {
        return (
            <InputGroup>
                <InputLeftElement
                    pointerEvents="none"
                    color={darkMode ? 'dark.textDark' : 'gray.500'}
                    fontSize="lg"
                    sx={{ paddingBottom: '10px', paddingRight: '8px' }}>
                    {displayPrefix}
                </InputLeftElement>
                <Input
                    {...inputProps}
                    sx={{
                        ...inputProps.sx,
                        paddingLeft: '1.5rem !important',
                    }}
                />
            </InputGroup>
        );
    }

    return <Input {...inputProps} />;
}
